import { KeyboardEvent, ReactNode, useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '../form';
import {
  Dialog,
  DialogActions,
  DialogButton,
  DialogButtonProps,
  DialogContent,
  ModalInstance,
} from './utils';

const confirmDialog = new ModalInstance<ConfirmOptions>('ConfirmDialog');

export default function ConfirmDialog() {
  const [options] = confirmDialog.useOptions();
  const [text, setText] = useState('');

  useEffect(() => setText(''), [options]);

  function onType(typedText: string) {
    if (options && typeof options.onType === 'function') {
      options.onType(typedText, options);
    }

    setText(typedText);
  }

  function onKeyUp(e: KeyboardEvent<HTMLDivElement>) {
    const isDisabled = Boolean(options?.confirmButton?.disabled);
    if (e.key === 'Enter' && !options?.textField?.multiline && !isDisabled) {
      confirmDialog.close(text);
    }
  }

  if (!options) {
    return null;
  }

  return (
    <Dialog
      onClose={() => confirmDialog.close('cancel')}
      onKeyUp={onKeyUp}
      title={options.title}
    >
      <DialogContent>
        {options.content}
        <TextField
          autoFocus
          margin="dense"
          onChange={(e) => onType(e.target.value)}
          value={text}
          {...options.textField}
        />
      </DialogContent>
      <DialogActions>
        <DialogButton
          disabled={!text}
          onClick={() => confirmDialog.close(text)}
          title="OK"
          {...options.confirmButton}
        />
        <DialogButton
          onClick={() => confirmDialog.close('cancel')}
          title="Cancel"
          type="secondary"
          {...options.cancelButton}
        />
      </DialogActions>
    </Dialog>
  );
}

export function showConfirmDialog(options: ConfirmOptions): Promise<string> {
  return confirmDialog.show(options);
}

export interface ConfirmOptions {
  cancelButton?: DialogButtonProps;
  confirmButton?: DialogButtonProps;
  content?: ReactNode;
  onType?: (text: string, options: ConfirmOptions) => void;
  textField?: TextFieldProps;
  title: string;
}
